import $ from 'jquery';
import { AdminPerson } from '../../classes/Person';
import { setDataAndShowDetailsModal } from 'static/components/details-modal/details-modal';
import { QuickMessageTemplateVM } from 'static/components/email-composer';
import { Modal } from 'bootstrap';
import { personLocale } from 'static/common/constants';

export function AllPeopleViewModel(data) {
    var self = this;
    self.type = "AllPeopleViewModel";

    self.rootvm = data.rootvm;

    self.initialized = ko.observable(false);
    self.initialize = async () => {

        console.log('initing people vm');

        if (!self.initialized()){
            await self.lookup_person_statuses()
            await self.lookup_people()
            self.initialized(true);
            console.log('done looking up people');
        }
    }

    self.total_count = ko.observable();
    self.filtered_count = ko.observable();
    self.offset = ko.observable(0);
    self.limit = ko.observable(30);

    self.people= ko.observableArray([]);

    self.error = ko.observable();
    self.person_name_search = ko.observable();

    self.person_statuses = ko.observableArray([]);

    self.payment_terms = ko.observableArray([
        { 'title': 'A -7 days after invoice', value: 'after invoice' },
        { 'title': 'B - 7 days before delivery (concert)', value: 'before delivery' },
        { 'title': 'C - After delivery (after concert date)', value: 'after delivery' }
    ]);
    self.search_name_click = function(){
        self.offset(0);
        console.log('searching with ', self.search_name());
        self.search_artist_name(undefined);
        self.search_host_name(undefined);
        self.lookup_people();
        return false;
    }

    self.search_host_name_click = function(){
        self.offset(0);
        console.log('searching with ', self.search_host_name());
        self.search_artist_name(undefined);
        self.search_name(undefined);
        self.lookup_people();
        return false;
    }

    self.search_artist_name_click = function(){
        self.offset(0);
        console.log('searching with ', self.search_artist_name());
        self.search_host_name(undefined);
        self.search_name(undefined);
        self.lookup_people();
        return false;
    }



    self.search_name = ko.observable();
    self.search_artist_name = ko.observable();
    self.search_host_name = ko.observable();

    self.set_selected_person = function (person, tabId) {
        setDataAndShowDetailsModal(person, tabId);
    }

    // First touch marketing source, shown when the referrer icon is clicked.
    self.selected_acquisition_person = ko.observable();

    self.show_acquisition_details = function (person) {
        self.selected_acquisition_person(person);
        Modal.getOrCreateInstance(
            document.getElementById('memberAcquisitionModal')).show();
    };

    self.quick_message_vm = new QuickMessageTemplateVM({ rootvm: self.rootvm });

    self.set_send_quick_message = (person) => {
        const vm = self.quick_message_vm;
        vm.display_name(self.rootvm.webapp_session().user().display_name());
        vm.person_uuid(person.person_uuid?.() ?? '');
        vm.recipient_name(person.display_name?.() ?? '');
        vm.language(undefined);
        vm.language(personLocale(person));
        Modal.getOrCreateInstance(document.getElementById('modalQuickMessage')).show();
    };

    self.get_login_link = function(person){
        person.get_login_link('/manage/account');
    }
    self.get_login_link_host = function(person){
        person.get_login_link('/manage/host/edit/basic', 'host');
    }
    self.get_login_link_artist = function(person){
        person.get_login_link('/manage/artist/edit/basic', 'artist');
    }

    self.lookup_person_statuses = async function () {
        try {
            const response = await fetch('/api/admin/person-statuses', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json; charset=utf-8'
                }
            });
            const data = await response.json();
            self.person_statuses(data.person_statuses);
        } catch (error) {
            self.error(error.message);
        }
    }

    self.lookup_people = function(){
        self.rootvm.is_busy(true);
        return $.ajax({

            url: '/api/admin/people',
            type: 'GET',
            data:{
                limit: self.limit(),
                offset: self.offset(),
                search_name: self.search_name(),
                search_host: self.search_host_name(),
                search_artist: self.search_artist_name()
            },

            contentType: "application/json; charset=utf-8",

            success: function (data) {

                self.people(ko.utils.arrayMap( data.people || [],
                    function(x){
                        x.rootvm = self.rootvm
                        return new AdminPerson(x);
                    }));

                self.total_count(data.total_count);
                self.filtered_count(data.filtered_count);

            },

            error: function (data) {
                self.error(data.statusText);
            },
            complete: function(){
                self.rootvm.is_busy(false);
            }
        });
    };

    self.lookup_upcoming_events = async function () {
        try {
            const response = await fetch(self.rootvm.web_host + '/api/events/upcoming', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json; charset=utf-8'
                }
            });
            const data = await response.json();
            self.upcoming_events(ko.utils.arrayMap(data.events || [], function (x) {
                x.rootvm = self.rootvm;
                return new SCEvent(x);
            }));
        } catch (error) {
            self.error(error.message);
        }
    };

    self.lower_count_label = ko.computed(function(){
        return parseInt(self.offset()) + 1;
    });

    self.upper_count_label = ko.computed(function(){
        if (parseInt(self.limit()) + parseInt(self.offset()) > self.filtered_count())
        {
            return self.filtered_count();
        }
        else
        {
            return parseInt(self.limit()) + parseInt(self.offset());
        }
    });

    self.paging_visible = ko.computed(function () {
        return self.total_count() > 0;
    });

    self.next_button_visible = ko.computed(function() {
        return parseInt(self.offset()) + parseInt(self.limit()) < self.filtered_count();
    });

    self.previous_button_visible = ko.computed(function () {
        return parseInt(self.offset()) > 0;
    });



    self.go_left = function () {

        if (self.rootvm.is_busy()){
            return false;}

        self.offset(parseInt(self.offset()) - parseInt(self.limit()));

        self.lookup_people().then(function(){
            pager.navigate("#community/members"
                + "?offset="
                + self.offset()
                + "&limit="
                + self.limit()
            );
        });
    };

    self.go_right = function () {

        if (self.rootvm.is_busy()){
            return false;}

        self.offset(parseInt(self.offset()) + parseInt(self.limit()));
        self.lookup_people().then(function(){
            pager.navigate("#community/members"
                + "?offset="
                + self.offset()
                + "&limit="
                + self.limit()
            );
           });
    };
};
